(function(w) {
  'use strict';

  // Pg.Errors module
  Pg.Errors = {
    
    // ================================================================
    // ERROR SEVERITY LEVELS
    // ================================================================
    
    SEVERITY: {
      LOW: 'low',
      MEDIUM: 'medium', 
      HIGH: 'high',
      CRITICAL: 'critical'
    },

    // ================================================================
    // ERROR TRACKING
    // ================================================================
    
    // Error log storage
    errors: [],
    
    // Error statistics
    stats: {
      total: 0,
      byLevel: {
        low: 0,
        medium: 0,
        high: 0,
        critical: 0
      },
      lastError: null
    },

    // Error handling configuration
    config: {
      showToasts: false,         // Show user notifications
      logToConsole: true,       // Log to browser console
      toastDuration: 5000       // Toast display duration (ms)
    },

    // ================================================================
    // CORE ERROR HANDLING
    // ================================================================
    
    // Handle error with context and severity
    handle(error, context = 'unknown', severity = 'medium') {
      try {
        // Create error info object
        const errorInfo = {
          message: error?.message || String(error),
          context,
          severity,
          timestamp: new Date().toISOString(),
          stack: error?.stack
        };
        
        // Store error
        this.errors.push(errorInfo);
        this.stats.total++;
        this.stats.byLevel[severity]++;
        this.stats.lastError = errorInfo;
        
        // Log to console
        if (this.config.logToConsole) {
          const prefix = this._getSeverityEmoji(severity);
          console.error(`${prefix} [${severity.toUpperCase()}] ${context}:`, errorInfo);
        }
        
        // Show user notification for high severity
        if (this.config.showToasts && (severity === 'high' || severity === 'critical')) {
          this.showToast(`Error: ${errorInfo?.message}`, 'error');
        }
        
        return errorInfo;
        
      } catch (handlingError) {
        console.error('❌ Error in error handler:', handlingError);
        return null;
      }
    },

    // Safe execution wrapper for synchronous functions
    safe(func, context = 'unknown', fallback = null) {
      try {
        return func();
      } catch (error) {
        this.handle(error, context, 'medium');
        return fallback;
      }
    },

    // Safe execution wrapper for async functions
    async safeAsync(func, context = 'unknown', fallback = null) {
      try {
        return await func();
      } catch (error) {
        this.handle(error, context, 'medium');
        return fallback;
      }
    },

    // ================================================================
    // USER NOTIFICATIONS
    // ================================================================
    
    // Show toast notification to user
    showToast(message, type = 'error') {
      try {
        cLog(`🍞 Toast: ${message} (${type})`);
        
        // Create toast element
        const toast = document.createElement('div');
        toast.textContent = message;
        toast.style.cssText = `
          position: fixed; top: 20px; right: 20px; z-index: 10000;
          background: ${type === 'error' ? '#ff4444' : '#44ff44'};
          color: white; padding: 12px; border-radius: 4px;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          font-size: 14px; max-width: 300px; cursor: pointer;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        `;
        
        document.body.appendChild(toast);
        
        // Auto-remove after duration
        setTimeout(() => {
          if (toast.parentNode) {
            toast.parentNode.removeChild(toast);
          }
        }, this.config.toastDuration);
        
        // Click to dismiss
        toast.addEventListener('click', () => {
          if (toast.parentNode) {
            toast.parentNode.removeChild(toast);
          }
        });
        
      } catch (error) {
        console.warn('Failed to show toast:', error);
      }
    },

    // ================================================================
    // ERROR MANAGEMENT
    // ================================================================
    
    // Get error statistics
    getStats() {
      return {
        ...this.stats,
        recentErrors: this.errors.slice(-5)
      };
    },

    // Clear all stored errors
    clearErrors() {
      this.errors = [];
      this.stats.total = 0;
      this.stats.byLevel = { low: 0, medium: 0, high: 0, critical: 0 };
      this.stats.lastError = null;
      cLog('🧹 Error log cleared');
    },

    // ================================================================
    // PRIVATE HELPER METHODS
    // ================================================================
    
    // Get emoji for severity level
    _getSeverityEmoji(severity) {
      const emojiMap = {
        'low': 'ℹ️',
        'medium': '⚠️', 
        'high': '❌',
        'critical': '🚨'
      };
      return emojiMap[severity] || '❓';
    },

    // ================================================================
    // INITIALIZATION & MODULE UTILITIES
    // ================================================================
    
    // Initialize error handler
    init() {
      cLog('🛡️ Initializing Products Gallery Error Handler...');
      
      // Set up global error handler
      w.addEventListener('error', (event) => {
        this.handle(event.error, 'global', 'high');
      });
      
      // Set up unhandled promise rejection handler
      w.addEventListener('unhandledrejection', (event) => {
        this.handle(event.reason, 'promise-rejection', 'high');
      });
      
      cLog('✅ Products Gallery Error Handler ready');
    },

    // Log module info
    logInfo() {
      console.groupCollapsed('📦 Pg.Errors module loaded - Available features:');
      console.log('🛡️ Error handling features:', [
        'Safe execution wrappers',
        'Error tracking & statistics',
        'User notifications',
        'Global error handling'
      ]);
      console.log(Object.keys(this).filter(key => typeof this[key] === 'function'));
      console.groupEnd();
    }
  };

  // Auto-initialize
  Pg.Errors.init();

  // Mark module as loaded
  if (Pg.moduleStatus) {
    Pg.moduleStatus.errors = true;
    Pg.checkModules?.();
  }

  // Auto-log on load (can be disabled)
  if (typeof w !== 'undefined' && !Pg._silentLoad) {
    Pg.Errors.logInfo();
  }

})(window); 
